export enum HealthStatus {
	HEALTHY,
	UNHEALTHY,
	WARNING,
	UNKNOWN
}

export interface CustomProperty {
	title: string;
	value: string;
	mono?: boolean; // render mono unless explicitly false
	kind?: 'warn' | 'err'; // tint; absent = no tint
}

export interface Health {
	key: string;
	title: string;
	status: HealthStatus;
	message: string;
	timestamp: string;
	lastUnhealthyAt: string;
	customProperties?: CustomProperty[];
	excludeFromRefreshAll?: boolean;
	// Structural marker for an intentionally-retired telemetry source (Common#259) — the
	// leaf still renders (grey UNKNOWN tile + message) but is excluded from rollup/counts/
	// auto-expand. Absent/false on every leaf that isn't retired, incl. older backends.
	retired?: boolean;
	// Mute state (Core.Monitor#64). Absent when unmuted — Core.Monitor serializes
	// WhenWritingDefault — so falsy checks are correct and this UI can deploy before the backend.
	// Always evaluate against a ticker-driven `now`: an elapsed mutedUntil is unmuted client-side
	// with no refetch, and spliceLeaf preserves object identity for untouched leaves.
	mutedUntil?: string;
	mutedReason?: string;
	mutedBy?: string;
	children: Health[];
	// Check cadence in seconds, published on the response root only. Optional: Core.Monitor
	// serializes WhenWritingDefault so a 0 is dropped, and an older deploy won't send it at all.
	// Absent means "freshness unknown" — never treat that as fresh.
	checkIntervalSeconds?: number;
}
